import LoaderImage from 'static/images/loader.svg';
import React from 'react';

const Loader = () => (
    <div className="loader" aria-label="Loading">
        <img src={LoaderImage} alt="Loading" title="Loading" />
    </div>
);

export default Loader;
